import React from 'react'
import Select from 'react-select'
import {
  // Button,
  FormDashboardTextarea as Textarea,
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  Radio,
  RedDot,
  FormRow,
  FormDashboardInputNumber,
  PinPointInput
} from '../../../components'
import { ProgressBar } from '.'
import { Link } from 'react-router-dom'
import colors from '../../../utils/colors'
import { FormGallery } from './form-gallery'
import { NotificationFormPopup } from './notification-form-popup'

const Form = ({form, updateForm}) => {
  //eslint-disable-next-line
  const [notificationFormPopedUp, setNotificationFormPopedUp] = React.useState(false)

  var curr = new Date();
  curr.setDate(curr.getDate() + 3);
  var date = curr.toISOString().substr(0,10);

  return (
    <form>
      <div className="lg:hidden mobile-fullwidth">
        <div className="p-5 mb-8" style={{background: '#f5f5f5'}}>
          {
            form.registrationType === 'internal' &&
            <ProgressBar progress={30} total={100} />
          }
          <div className="text-center">
            {
              form.registrationType === 'internal' &&
              <div>
                <p className="text-sm text-gray-444">
                  Guest Total: 30/100
                </p>
                <div className="flex justify-center items-center mb-4">
                  <p className="text-sm text-primary underline mr-1">
                    <Link to="/dashboard/events/guest-list">
                      View Guests
                    </Link>
                  </p>
                  <RedDot />
                </div>
              </div>
            }
            <p className="text-sm text-gray-444 mb-4">
              Status: <strong>Published</strong>
            </p>
            <p className="text-sm text-gray-444 mb-4">
              Event Status: <span style={{color: colors.green}}>Upcoming</span>
            </p>
            <p className="text-sm text-gray-444">
              Registration end date: <br/>Aug/20/2020
            </p>
          </div>
        </div>
      </div>
      <p className="text-lg font-bold mb-5 lg:mb-8">Event Profile</p>
      <FormRow>
        <Label>Title (English)</Label>
        <Input className="w-full" defaultValue="Indonesia Millenial Summit 2020"/>
      </FormRow>
      <FormRow>
        <Label>Title (Indonesia)</Label>
        <Input className="w-full" defaultValue="Indonesia Millenial Summit 2020"/>
      </FormRow>
      <FormRow>
        <Label>Registration Type</Label>
        <div className="flex items-center justify-between lg:justify-start mb-3 pt-1">
          <Radio
            name="registrationType"
            id="type1"
            label="External Link"
            value="external"
            className="mr-2 lg:mr-10"
            form={form}
            onChange={updateForm}
          />
          <Radio
            name="registrationType"
            id="type2"
            label="Internal (via KHUB and Free)"
            value="internal"
            form={form}
            onChange={updateForm}
          />
        </div>
        {
          form.registrationType === 'external' &&
          <Input className="w-full" placeholder="Link" defaultValue="eventbrite.com/e/peace-in-times-of-suffering-in-times-of-loss-tickets-1075..."/>
        }
        {

          form.registrationType === 'internal' &&
          <div className="flex items-center justify-end lg:justify-start my-2 lg:w-2/3 lg:ml-auto">
            <p className="mr-2 text-gray-444 text-sm">Guest seat</p>
            <FormDashboardInputNumber className="w-32"/>
          </div>
        }
      </FormRow>

      <FormRow>
        <Label>Registration Date</Label>
        <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
          <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
            <p className="text-sm mb-3">Start Date</p>
            <Input className="w-full" type="date" defaultValue={date}/>
          </div>
          <div className="w-full lg:w-1/2 px-4">
            <p className="text-sm mb-3">End Date</p>
            <Input className="w-full" type="date" defaultValue={date}/>
          </div>
        </div>
      </FormRow>

      <FormRow>
        <Label>Event Date</Label>
        <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
          <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
            <p className="text-sm mb-3">Start Date</p>
            <Input className="w-full" type="date" defaultValue={date}/>
          </div>
          <div className="w-full lg:w-1/2 px-4">
            <p className="text-sm mb-3">End Date</p>
            <Input className="w-full" type="date" defaultValue={date}/>
          </div>
        </div>
      </FormRow>

      <FormRow>
        <Label>About (English)</Label>
        <Textarea
          className="w-full"
          rows={10}
          defaultValue={
            `Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.

            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud ollit non deserunt ullamco est sit aliqua dolor do amet sint. `
          }
        />
      </FormRow>
      <FormRow>
        <Label>About (Indonesia)</Label>
        <Textarea
          className="w-full"
          rows={10}
          defaultValue={
            `Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.

            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud ollit non deserunt ullamco est sit aliqua dolor do amet sint. `
          }
        />
      </FormRow>

      <hr className="my-8 lg:my-10"/>

      <p className="text-lg font-bold mb-5 lg:mb-8">Location</p>
      <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
        <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
          <Label>Province</Label>
          <Select className="text-sm" options={[]} placeholder="Choose Province" />
        </div>
        <div className="w-full lg:w-1/2 px-4">
          <Label>City</Label>
          <Select className="text-sm" options={[]} placeholder="Choose City" />
        </div>
      </div>
      <FormRow>
        <Label>Address</Label>
        <Input className="w-full" defaultValue="Jl. Cijagra No.48, Cijagra, Lengkong, Kota Bandung 40265"/>
      </FormRow>
      <div className="mb-8">
        <Label>Pin Point</Label>
        <PinPointInput />
      </div>

      <hr className="my-8 lg:my-10"/>

      <FormGallery />

      <hr className="my-8 lg:hidden"/>

      {
        notificationFormPopedUp &&
        <NotificationFormPopup onClose={(val) => setNotificationFormPopedUp(val)}/>
      }
    </form>
  )
}

export { Form }
